const fields = {
  id: {
    type: String,
    default: () => '',
  },
  integer: {
    type: Number,
    default: () => 0
  },
  string: {
    type: String,
    default: () => ''
  },
  slug: {
    type: String,
    default: () => ''
  },
  text: {
    type: String,
    default: () => ''
  },
  email: {
    type: String,
    default: () => ''
  },
  datetime: {
    type: Date,
    default: () => new Date()
  },
  bool: {
    type: Boolean,
    default: () => false
  },
  image: {
    type: File,
    default: () => null
  },
  relation: {
    type: Object,
    default: () => null
  },
  json: {
    type: Object,
    default: () => ({})
  },
  media: {
    type: [ Object, Array ],
    default: null
  },
  upload: {
    type: String,
    default: () => ''
  },
  tags: {
    type: [ Number, Object, Array ],
    default: () => []
  },
  title: {
    type: String,
    default: () => '',
    component: 'f-string'
  },
  summary: {
    type: String,
    default: () => '',
    component: 'f-text'
  },
  collections: {
    type: [ Number, Object, Array ],
    default: () => []
  },
  content_restrictions: {
    type: Object,
    default: () => null,
    component: 'f-content-restrictions'
  },
  user: {
    type: [ Number, Object ],
    default: () => []
  },
  users: {
    type: [ Number, Object, Array ],
    default: () => []
  },
  override: {
    type: Object,
    default: () => null
  },
}

export default fields
